/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import qualifyCredentialsService from '@resources/scripts/services/qualifyCredentials.service';
import axios from 'axios';
import { QUALIFY_CREDENTIALS_FORM } from '../mutation-types';
import qualifyCredentialsApi from '../../services/api/qualifyCredentials.js';
import { setState } from '../mutationHelpers';
import { QualifyCredentialsStorePayload } from '../../models';

const namespaced = true;

const state = {
  formFields: {
    typeOfRecipient: '',
    contactTitle: '',
    contactFirstName: '',
    contactLastName: '',
    companyName: '',
    addressLineOne: '',
    addressLineTwo: '',
    companyCity: '',
    companyState: '',
    companyCountry: '',
    companyZip: '',
    companyEmail: '',
    companyFax: '',
    additionalTypeOfRecipient: '',
    additionalContactTitle: '',
    additionalFirstName: '',
    additionalContactLastName: '',
    additionalCompanyName: '',
    additionalAddressLineOne: '',
    additionalAddressLineTwo: '',
    additionalCompanyCity: '',
    additionalCompanyCountry: '',
    additionalCompanyState: '',
    additionalCompanyZip: '',
    additionalCompanyEmail: '',
    additionalCompanyFax: '',
    thirdAdditionalTypeOfRecipient: '',
    thirdAdditionalContactTitle: '',
    thirdAdditionalFirstName: '',
    thirdAdditionalContactLastName: '',
    thirdAdditionalCompanyName: '',
    thirdAdditionalAddressLineOne: '',
    thirdAdditionalAddressLineTwo: '',
    thirdAdditionalCompanyCity: '',
    thirdAdditionalCompanyState: '',
    thirdAdditionalCompanyCountry: '',
    thirdAdditionalCompanyZip: '',
    thirdAdditionalCompanyEmail: '',
    thirdAdditionalCompanyFax: '',
    contractorContactTitle: '',
    contractorFirstName: '',
    contractorContactLastName: '',
    contractorCompanyEmail: '',
    woodworkingFirm: '',
  } as QualifyCredentialsStorePayload,
  currentPage: 1,
  countryOptions: [],
  submitting: false,
  submitted: false,
};

const getters = {
  countryOptions: storeState => storeState.countryOptions,
  stateProvinceOptions: storeState => countryName => (storeState.countryOptions.find(x => x.name === countryName) ? storeState.countryOptions.find(x => x.name === countryName).stateProvinces : []),
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [QUALIFY_CREDENTIALS_FORM.UPDATE_COUNTRY_OPTIONS]: setState('countryOptions'),
  [QUALIFY_CREDENTIALS_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [QUALIFY_CREDENTIALS_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [QUALIFY_CREDENTIALS_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [QUALIFY_CREDENTIALS_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },
};

const actions = {
  goToNextPage({ commit }) {
    commit(QUALIFY_CREDENTIALS_FORM.CHANGE_CURRENT_PAGE, state.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit }) {
    commit(QUALIFY_CREDENTIALS_FORM.CHANGE_CURRENT_PAGE, state.currentPage - 1);
    window.scrollTo(0, 0);
  },

  async getCountries({ commit }) {
    const { data } = await axios.get('/api/countries');
    commit(QUALIFY_CREDENTIALS_FORM.UPDATE_COUNTRY_OPTIONS, data);
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(QUALIFY_CREDENTIALS_FORM.TOGGLE_SUBMITTING_STATE, true);
      const createPayload = qualifyCredentialsService.buildCreatePayload(actionState.formFields);
      try {
        await qualifyCredentialsApi.create(createPayload);
        commit(QUALIFY_CREDENTIALS_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Qualify Credentials - Submitted',
            page_path: '/forms/qualify-credentials/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(QUALIFY_CREDENTIALS_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};